import React from "react";
import { connect } from "react-redux";
import Modal from "Components/smallModal/smallModal";
import OTPConfig from "./OTPConfig";
import Button from "Components/button/Button";
import * as formActions from "../../modules/forms";
import * as sessionActions from "../../modules/session";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import cx from "classnames";
import s from "./OTP.scss";
import { alertSuccess } from "Utils/alerts";

import { view, store } from "@risingstack/react-easy-state";

class Otp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configModalOpened: false,
    };
  }

  openConfiguration() {
    this.setState({ configModalOpened: true });
  }

  handleClose = () => {
    this.setState({
      configModalOpened: false,
    });
  };

  getOptModalTitle = () => {
    let title = "";
    if (!this.props.session.user.otp) {
      title = t("modal.otp.app.title");
    }
    if (!this.props.session.user.otp) {
      title = t("modal.otp.enable.title");
    }
    if (this.props.session.user.otp) {
      title = t("modal.otp.disable.title");
    }
    return title;
  };

  render() {
    const { user } = this.props.session;
    const { configModalOpened } = this.state;
    const { className } = this.props;

    let cta = user.otp ? `button.disableOTP` : `button.enableOTP`;
    let optForced = user.domain_force_otp || user.force_otp;

    return (
      <div className={cx(className, s.otp)}>
        <Button
          className={s.btn}
          type="button"
          color={user.otp ? "red-outline" : "outline"}
          onClick={this.openConfiguration.bind(this)}
          disabled={user.otp && optForced}
        >
          {cta}
        </Button>
        {user.otp && optForced && <TranslatedString>infoMsg.otp.cantDisable</TranslatedString>}

        <Modal title={this.getOptModalTitle()} opened={configModalOpened} closeModal={this.handleClose} withForm>
          <OTPConfig
            user={user}
            onSuccess={() => {
              this.props.refreshLoggedUserData();
              this.setState({ configModalOpened: false });
            }}
            onCancel={this.handleClose}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  refreshLoggedUserData: () => {
    dispatch(sessionActions.verify(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Otp);
